module.exports = __webpack_public_path__ + "01f43047/img/boston-lights.a623432f.png";